import { Logger } from "./utils/logger";

export class Controller {
    logLabel: string;

    constructor({ logLabel }: { logLabel: string }) {
        this.logLabel = logLabel;
    }

    getElementByIdOrWarn<T extends HTMLElement>(elementId: string): T | null {
        const element = document.getElementById(elementId);
        if (!element) {
            Logger.warn(this.logLabel, `Could not find element with ID: ${elementId}`);
            return null;
        }
        return element as T;
    }

    bindClick({ elementId, handler }: { elementId: string; handler: EventListener }): void {
        const element = this.getElementByIdOrWarn(elementId);
        if (element) {
            element.addEventListener("click", handler);
        }
    }

    parseErrors(data: string | Record<string, string | string[]>): string[] {
        const errors: string[] = [];
        if (typeof data === "string") {
            errors.push(data);
        } else if (typeof data === "object" && data !== null) {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    const value = data[key];
                    const formattedKey = key.charAt(0).toUpperCase() + key.slice(1);

                    if (typeof value === "string") {
                        errors.push(`${formattedKey} - ${value}`);
                    } else if (Array.isArray(value)) {
                        value.forEach((errorMessage) => {
                            errors.push(`${formattedKey} - ${errorMessage}`);
                        });
                    }
                }
            }
        } else {
            errors.push("An unknown error occurred.");
        }
        return errors;
    }
}
